
import { ArticleFormData } from "@/types/article-types";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { processTagsForSubmission } from "./articleUtils";

export const useArticleUpdater = (loadArticles: () => Promise<void>) => {
  const { toast } = useToast();

  const updateArticle = async (id: string, articleData: ArticleFormData) => {
    try {
      console.log("Updating article with data:", articleData);
      
      // Process tags properly
      const tags = processTagsForSubmission(articleData.tags);
      console.log("Processed tags for update:", tags);
        
      const { error } = await supabase
        .rpc('update_article', {
          article_id: id,
          title: articleData.title,
          lead_text: articleData.lead_text || '',
          content: articleData.content,
          header_image_url: articleData.header_image_url || null,
          author_id: articleData.author_id,
          tags: tags,
          status: articleData.status,
          publish_date: articleData.publish_date || null
        });

      if (error) {
        console.error("Supabase RPC error:", error);
        throw error;
      }
      
      console.log("Article updated successfully");
      
      // Refresh the articles list
      await loadArticles();
      
      return true;
    } catch (error: any) {
      console.error('Error updating article:', error);
      toast({
        variant: "destructive",
        title: "Error updating article",
        description: error.message || "Failed to update article"
      });
      return false;
    }
  };

  return {
    updateArticle
  };
};
